<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
.table-dashboard tfoot tr td {
    background: #1f2248;
    color: #fff;
}
.new-pemungut{
    border-bottom: 1px solid #000000 !important;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="LAPORAN KUTIPAN HARIAN">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Tarikh Dari"
                            type="date"
                        />
                        <w-input
                            v-model="cari.kod_pp"
                            required
                            label="Kod P.P"
                            type="text"
                        />
                        <z-lookup
                            label="Jenis Kaunter"
                            name="jenisKaunter"
                            :url="service_laporan + 'lookup/lkp_kaunter'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_kaunter_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Tarikh Hingga"
                            type="date"
                        />
                        <z-lookup
                            label="Cara Bayar"
                            name="jenisKaunter"
                            :url="service_laporan + 'lookup/cara_bayar'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_cara_bayar_id"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>BIL.</td>
                                <td style="min-width: 110px;">TARIKH RESIT</td>
                                <td>NO. RESIT</td>
                                <td>KOD PREMIS/KOD HASIL</td>
                                <td>NAMA PEMILIK</td>
                                <td>KOD P.P</td>
                                <td>AMAUN (RM)</td>
                                <td>CARA BAYAR</td>
                                <td>JENIS KAUNTER</td>
                                <td>PEGAWAI KAUNTER</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.items.length > 0">
                                <tr v-for="(dt, index) in table.items">
                                    <td style="text-align: center">{{ index+1 }}</td>
                                    <td style="text-align: center">{{ dt.tarikh_bayar }}</td>
                                    <td style="text-align: center">{{ dt.no_resit }}</td>
                                    <td style="text-align: center">{{ dt.kod_premis }}</td>
                                    <td style="text-align: center">{{ dt.nama_pemilik }}</td>
                                    <td style="text-align: center">{{ dt.no_penyata_pemungut }}</td>
                                    <td style="text-align: right">{{ dt.amaun }}</td>
                                    <td style="text-align: center">{{ dt.cara_bayar }}</td>
                                    <td style="text-align: center">{{ dt.kaunter }}</td>
                                    <td style="text-align: center">{{ dt.name }}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="9" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="6"><b>JUMLAH (RM)</b></td>
                                <td style="text-align: right"><b>{{table.total_amaun}}</b></td>
                                <td colspan="3"><b>&nbsp;</b></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            loading: false,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Perumahan", route: "/perumahan/laporan/kutipan_harian" },
                { label: "Laporan", route: "/perumahan/laporan/kutipan_harian" },
                {
                    label: "Laporan Kutipan Harian",
                    route: "/perumahan/laporan/kutipan_harian",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", kod_pp: "", lkp_kaunter_id: "", lkp_cara_bayar_id: ""  },
        };
    },
    methods: {
        search() {
            this.getQueryData();
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", kod_pp: "", lkp_kaunter_id: "", lkp_cara_bayar_id: ""  };
            this.search();
        },

        cetak() {
            window.open(this.service_laporan+'perumahan/laporan/kutipan_harian?cetak=1&user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga +
            "&kod_pp=" + this.cari.kod_pp +
            "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id +
            "&lkp_cara_bayar_id=" + this.cari.lkp_cara_bayar_id,'_blank');
        },
        async getQueryData() {
            this.loading = true;
            const resp = await axios.get(
                this.service_laporan + "perumahan/laporan/kutipan_harian?user_id=" + this.auth.user.id +
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&kod_pp=" + this.cari.kod_pp +
                    "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id +
                    "&lkp_cara_bayar_id=" + this.cari.lkp_cara_bayar_id
            );
            this.table = resp.data;
            this.loading = false;
        },
    },
    watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.akaun_id == "undefined") {
            this.cari.akaun_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
